<div class="main-container" style="margin-bottom: 60px">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>General Information</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>
        <app-mat-text-input
          [formControl]="getFormControl('extension')"
          [readonly]="true"
          label="Extension"
          name="extension"
        ></app-mat-text-input>
        <app-mat-text-input
          [formControl]="getFormControl('firstName')"
          label="First Name"
          name="firstName"
          [submitted]="submitted"
        ></app-mat-text-input>
        <app-mat-text-input
          [formControl]="getFormControl('lastName')"
          label="Last Name"
          name="lastName"
          [submitted]="submitted"
        ></app-mat-text-input>
        <app-mat-text-input
          [formControl]="getFormControl('emailAddress')"
          label="Email addresses for extension"
          name="emailAddress"
          [submitted]="submitted"
        ></app-mat-text-input>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title>Call Forward to Another Extension</mat-card-title>
      <mat-card-content *ngIf="!editModel.isCallForwardAvailable">
        <p-message
          severity="warn"
          text="Call Forward Settings are unavailable because this extension belongs to an Agent Group or a Hunt Group."
        >
        </p-message>
      </mat-card-content>
      <mat-card-content *ngIf="editModel.isCallForwardAvailable">
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>
        <app-mat-multiselect
          [formControl]="getFormControl('cfa')"
          [submitted]="submitted"
          [autoCompleteValues]="pbxService.accountsLookupList"
          [allowCustomValue]="false"
          [limit]="1"
          placeholder="Enter cell phone number or extension"
          label="Call forward all calls to"
          validator="phoneNumber"
        ></app-mat-multiselect>

        <app-mat-simple-select
          [formControl]="getFormControl('cfaNumbers')"
          label="Call Type"
          name="cfaNumbers"
          *ngIf="getFormControl('cfa').value?.length > 0"
          [selectItems]="pbxService.callForwardTypes"
          [submitted]="submitted"
        ></app-mat-simple-select>

        <app-mat-simple-select
          [formControl]="getFormControl('cfaTimes')"
          label="Call Times"
          name="cfaTimes"
          *ngIf="getFormControl('cfa').value?.length > 0"
          [selectItems]="pbxService.callForwardTimes"
          [submitted]="submitted"
        ></app-mat-simple-select>

        <app-mat-multiselect
          [formControl]="getFormControl('cfb')"
          [submitted]="submitted"
          [autoCompleteValues]="pbxService.accountsLookupList"
          [allowCustomValue]="false"
          [limit]="1"
          placeholder="Enter cell phone number or extension"
          label="Call forward calls when busy to"
          validator="phoneNumber"
        ></app-mat-multiselect>

        <app-mat-simple-select
          [formControl]="getFormControl('cfbNumbers')"
          label="Call Type"
          name="cfbNumbers"
          *ngIf="getFormControl('cfb').value?.length > 0"
          [selectItems]="pbxService.callForwardTypes"
          [submitted]="submitted"
        ></app-mat-simple-select>

        <app-mat-simple-select
          [formControl]="getFormControl('cfbTimes')"
          label="Call Times"
          name="cfbTimes"
          *ngIf="getFormControl('cfb').value?.length > 0"
          [selectItems]="pbxService.callForwardTimes"
          [submitted]="submitted"
        ></app-mat-simple-select>

        <app-mat-multiselect
          [formControl]="getFormControl('cfn')"
          [submitted]="submitted"
          [autoCompleteValues]="pbxService.accountsLookupList"
          [allowCustomValue]="false"
          [limit]="1"
          placeholder="Enter cell phone number or extension"
          label="Call forward on no answer to"
          validator="phoneNumber"
        ></app-mat-multiselect>

        <app-mat-simple-select
          [formControl]="getFormControl('cfnNumbers')"
          label="Call Type"
          name="cfnNumbers"
          *ngIf="getFormControl('cfn').value?.length > 0"
          [selectItems]="pbxService.callForwardTypes"
          [submitted]="submitted"
        ></app-mat-simple-select>

        <app-mat-simple-select
          [formControl]="getFormControl('cfbTimes')"
          label="Call Times"
          name="cfnTimes"
          *ngIf="getFormControl('cfn').value?.length > 0"
          [selectItems]="pbxService.callForwardTimes"
          [submitted]="submitted"
        ></app-mat-simple-select>

        <app-mat-multiselect
          [formControl]="getFormControl('cfd')"
          [submitted]="submitted"
          [autoCompleteValues]="pbxService.accountsLookupList"
          [allowCustomValue]="false"
          [limit]="1"
          placeholder="Enter cell phone number or extension"
          label="Call forward when not registered"
          validator="phoneNumber"
        ></app-mat-multiselect>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title>Call Forward to a Cell Phone</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>
        <app-mat-multiselect
          [formControl]="getFormControl('cellDis')"
          [submitted]="submitted"
          placeholder="Enter cell phone numbers"
          label="Cell Phone Numbers"
          validator="phoneNumber"
        ></app-mat-multiselect>
        <app-mat-checkbox-input
          [formControl]="getFormControl('cellConn')"
          label="Offer special menu when call is answered on cell phone"
          name="cellConn"
          [explanation]="cellConnExplanation"
          (ngModelChange)="specialMenuChanged($event)"
          [submitted]="submitted"
        ></app-mat-checkbox-input>
        <app-mat-checkbox-input
          [formControl]="getFormControl('vpaEnabled')"
          label="Offer Personal Virtual Assistant when this cell phone calls the PBX"
          name="vpaEnabled"
          [submitted]="submitted"
        ></app-mat-checkbox-input>
        <app-mat-simple-select
          [formControl]="getFormControl('cellTime')"
          label="When calling extension directly"
          name="cellTime"
          [selectItems]="pbxService.cellTimes"
          [submitted]="submitted"
        ></app-mat-simple-select>
        <app-mat-simple-select
          [formControl]="getFormControl('cellHunt')"
          label="When calling the extension in a Hunt Group"
          name="cellHunt"
          [selectItems]="pbxService.cellGroupOptions"
          [submitted]="submitted"
        ></app-mat-simple-select>
        <app-mat-simple-select
          [formControl]="getFormControl('cellAcd')"
          label="When calling the extension in a Agent Group"
          name="cellAcd"
          [selectItems]="pbxService.cellGroupOptions"
          [submitted]="submitted"
        ></app-mat-simple-select>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-title>Mailbox Settings</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>
        <app-mat-password-input
          [formControl]="getFormControl('mbPin')"
          label="PIN Number for my Mailbox"
          name="mbPin"
          [showPasswordIcon]="true"
          showPasswordTooltip="Show PIN"
          [customErrors]="{ pattern: 'Only Numbers Are Allowed' }"
          [submitted]="submitted"
        ></app-mat-password-input>
        <app-mat-simple-select
          [formControl]="getFormControl('mbEnable')"
          label="Mailbox enabled"
          name="mbEnable"
          [selectItems]="pbxService.mailboxTypes"
          [submitted]="submitted"
        ></app-mat-simple-select>
        <app-mat-simple-select
          [formControl]="getFormControl('mbTimeout')"
          label="Time until mailbox picks up"
          name="mbTimeout"
          [infoText]="
            getFormControl('cellConn').getRawValue()
              ? 'When offer special menu is selected, time until mailbox picks up must be 60 seconds.'
              : ''
          "
          [selectItems]="
            getFormControl('cellConn').getRawValue()
              ? pbxService.mailboxTimeOptionsFiltered
              : pbxService.mailboxTimeOptions
          "
          [submitted]="submitted"
        ></app-mat-simple-select>
        <app-mat-multiselect
          [formControl]="getFormControl('mailboxGroup')"
          [submitted]="submitted"
          [autoCompleteValues]="pbxService.extensionsLookupList"
          [allowCustomValue]="false"
          [excludeValues]="[{ id: editModel.name, text: editModel.name }]"
          placeholder="Enter other extensions"
          label="Send voicemails to additional mailboxes"
          validator="none"
        ></app-mat-multiselect>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-title>Email Settings</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>

        <app-mat-simple-select
          [formControl]="getFormControl('emailVmail')"
          label="Send a mailbox message by email"
          name="emailVmail"
          [selectItems]="pbxService.mailTypes"
          [submitted]="submitted"
        ></app-mat-simple-select>
        <app-mat-simple-select
          [formControl]="getFormControl('vmailOption')"
          *ngIf="getFormControl('emailVmail').value !== 'none'"
          label="Send a mailbox message by email"
          name="vmailOption"
          [selectItems]="pbxService.mailOptions"
          [submitted]="submitted"
        ></app-mat-simple-select>
        <app-mat-checkbox-input
          [formControl]="getFormControl('emailMissed')"
          label="Send email on missed calls"
          name="emailMissed"
          [submitted]="submitted"
        ></app-mat-checkbox-input>
        <app-mat-checkbox-input
          [formControl]="getFormControl('emailAll')"
          label="Send email at the end of every call"
          name="emailAll"
          [submitted]="submitted"
        ></app-mat-checkbox-input>
        <app-mat-checkbox-input
          [formControl]="getFormControl('emailMbFull')"
          label="Send email when mailbox is full"
          name="emailMbFull"
          [submitted]="submitted"
        ></app-mat-checkbox-input>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title>E-911 Settings</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>
        <app-mat-simple-select
          [formControl]="getFormControl('eAni')"
          label="E-911 Address"
          name="eAni"
          (valueChanged)="onSelectedE911AddressChanged($event)"
          [selectItems]="e911Addresses"
          [submitted]="submitted"
        ></app-mat-simple-select>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="isButtonsAvailable$ | async" appearance="outlined">
      <mat-card-title>Buttons Settings</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>

        <mat-table *ngIf="accountDevicesList?.length; else noDevicesFound" [dataSource]="accountDevicesList">
          <ng-container matColumnDef="mac">
            <mat-header-cell *matHeaderCellDef>Mac</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span>{{ row.mac | macAddress }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="vendor">
            <mat-header-cell *matHeaderCellDef>Vendor</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span>{{ row.vendor }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="model">
            <mat-header-cell *matHeaderCellDef>Model</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span>{{ row.model }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row">
              <div
                matTooltip="There is no phone registered to this extension"
                [matTooltipDisabled]="!isDeviceEditDisabled(row)"
              >
                <button
                  type="button"
                  mat-button
                  [disabled]="isDeviceEditDisabled(row)"
                  (click)="onEditDeviceButtonsSettings(row)"
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                  <span>Edit</span>
                </button>
              </div>
              <span></span>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
        </mat-table>
      </mat-card-content>
    </mat-card>
  </form>
</div>
<div class="edit-action-bar">
  <button
    mat-raised-button
    type="button"
    color="primary"
    matTooltip="Save changes"
    (click)="onSubmit()"
    [disabled]="submitted"
    [promiseBtn]="buttonSubmitPromise"
    *ngIf="hasEditAccess"
  >
    Save
  </button>
</div>

<ng-template #noDevicesFound>
  <div>
    <p>No Devices Found</p>
  </div>
</ng-template>
